module.exports = __webpack_public_path__ + "img/1.08ff52d6.png";